(function ($, ko) {
    var contributionsAddEditPopup = function (contribution, dataPartnerId, onSuccess) {
        this.validDates = new $.cdh.get.contribution.getValidDates(dataPartnerId);
        this.bankAccounts = new $.cdh.get.bankAcount.getConfirmed(dataPartnerId);
        this.preview = ko.observable(false);
        this.success = ko.observable(false);

        this.AddEditBankAccountRequiredLabels = {
            lblVerifyAccountRequired: $.cdh.languageConstant.getConstant('contributions.verified-account-required'),
            lblCloseThisWindow: $.cdh.languageConstant.getConstant('contributions.close-this-window'),
            lblAddBankAccount: $.cdh.languageConstant.getConstant('contributions.add-bank-acccount'),
            lblAccountVerifiedReturnHere: $.cdh.languageConstant.getConstant('contributions.account-verified-return-here'),
            lblButtonClose: $.cdh.languageConstant.getConstant('button.close')
        };

        this.AddEditPopupLabels = {
            lblFundHsa: $.cdh.languageConstant.getConstant('title.fund-my-hsa'),
            lblContributionYear: $.cdh.languageConstant.getConstant('field.contribution-year'),
            lblContributionCountTaxYear: $.cdh.languageConstant.getConstant('contributions.contribution-count-tax-year'),
            lblContributionsMadeAfter: $.cdh.languageConstant.getConstant('contributions.contributions-made-after'),
            lblAppliedToCurrentYear: $.cdh.languageConstant.getConstant('contributions.applied-current-year'),
            lblContributionDate: $.cdh.languageConstant.getConstant('field.contribution-date'),
            lblAmount: $.cdh.languageConstant.getConstant('field.amount'),
            lblContributionsMayTake: $.cdh.languageConstant.getConstant('contributions.contributions-may-take'),
            lblBusinessDaysAfterContribution: $.cdh.languageConstant.getConstant('contributions.business-days-after-contribution'),
            lblBankAccount: $.cdh.languageConstant.getConstant('field.bank-account'),
            lblButtonCancel: $.cdh.languageConstant.getConstant('button.cancel'),
            lblButtonSubmit: $.cdh.languageConstant.getConstant('button.submit'),
        };

        this.AddEditPreviewLabels = {
            lblThankyou: $.cdh.languageConstant.getConstant('communication.thank-you'),
            lblContributionSubmitted: $.cdh.languageConstant.getConstant('messages.contribution-submitted'),
            lblContributionsMayTake: $.cdh.languageConstant.getConstant('contributions.contributions-may-take'),
            lblBusinessDaysAfterContribution: $.cdh.languageConstant.getConstant('contributions.business-days-after-contribution'),
            lblCurrentYear: $.cdh.languageConstant.getConstant('field.current-year'),
            lblContributionDetails: $.cdh.languageConstant.getConstant('communication.contribution-details'),
            lblAmount: $.cdh.languageConstant.getConstant('field.amount'),
            lblContributionDate: $.cdh.languageConstant.getConstant('field.contribution-date'),
            lblBankAccount: $.cdh.languageConstant.getConstant('field.bank-account'),
            lblButtonLoading: $.cdh.languageConstant.getConstant('button.loading'),
            lblButtonSubmit: $.cdh.languageConstant.getConstant('button.submit'),
            lblWhatNext: $.cdh.languageConstant.getConstant('payment.what-next'),
            lblSubmitAnother: $.cdh.languageConstant.getConstant('link.submit-another'),
            lblButtonClose: $.cdh.languageConstant.getConstant('button.close'),
            lblButtonCancel: $.cdh.languageConstant.getConstant('button.cancel'),
            lblButtonEdit: $.cdh.languageConstant.getConstant('button.edit')
        };

        this.preRender = function () {
            this.validDates.load();
            this.bankAccounts.load();
        }.bind(this);

        var c = ko.toJS(contribution);

        // CDH.ApiServices.Models.Contribution.EditPendingContribution
        this.contribution = {
            ContributionId: c.ContributionId,
            AccountId: c.AccountId,
            BankAccountId: ko.observable(c.BankAccountId).extend({ required: true }),
            ContributionYear: ko.observable(c.ContributionYear || $.cdh.enums.contributionYear.current),
            ContributionDate: ko.observable(c.ContributionDate).extend({ required: true }),
            ContributionAmount: ko.observable(c.ContributionAmount).extend({ min: 1.01, required: true }),
            Agree: ko.observable(false).extend({
                checked: {}
            })
        };

        this.validation = new $.cdh.validation(this.contribution);

        this.canPickPrior = ko.pureComputed(function () {            
            if (this.validDates.hasData()) {
                return moment() >= moment().startOf('year') &&
                    moment() <= moment(this.validDates.data().LatestPriorContributionDate);
            }
            return false;
        }, this);

        this.LatestPriorContributionDate = ko.pureComputed(function () {
            if (this.validDates.hasData()) {
                return this.validDates.data().LatestPriorContributionDate;
            }
            return null;
        }, this);

        this.minDate = ko.pureComputed(function () {
            if (this.validDates.hasData()) {
                return  this.validDates.data().EarliestContributionDate;
             }  
            return null;
        }, this);

        this.maxDate = ko.pureComputed(function () {
            return this.validDates.hasData() && this.contribution.ContributionYear() == $.cdh.enums.contributionYear.prior
                ? this.validDates.data().LatestPriorContributionDate
                : this.validDates.data().LatestCurrentContributionDate;
        }, this);

        this.ExternalAccountTransferDaysToDelay = ko.pureComputed(function () {
            return this.validDates.hasData()
                ? this.validDates.data().ExternalAccountTransferDaysToDelay
                : null;
        }, this);

        var model = this;
        this.currentYearSelected = ko.observable(this.contribution.ContributionYear || $.cdh.enums.contributionYear.current);
        this.priorYearSelected = ko.observable(!this.currentYearSelected());

        this.contribution.ContributionYear.subscribe(function (newValue) {
            model.currentYearSelected(newValue === $.cdh.enums.contributionYear.current);
            model.priorYearSelected(!model.currentYearSelected());
        });

        this.selectedBankAccountName = ko.pureComputed(function () {
            var bankAccountId = this.contribution.BankAccountId();
            if (!bankAccountId || !this.bankAccounts.data) {
                return "";
            }

            var bankAccount = $.grep(this.bankAccounts.data(),
                function(ba) {
                    return ba.BankAccountId == bankAccountId;
                })[0];
            if (bankAccount) {
                return bankAccount.BankAccountName;
            } else {
                return "";
            }
            
        }.bind(this));

        this.addOrEditRequest = c.ContributionId
            ? new $.cdh.post.contributions.edit(c.ContributionId)
            : new $.cdh.post.contributions.add();

        this.setClose = function (closeFunc) {
            this.close = closeFunc;
        }.bind(this);

        this.clickReset = function () {
            this.validation.activated(false);

            this.contribution.ContributionId = 0;
            this.contribution.ContributionAmount('');

            this.preview(false);
            this.success(false);
            return false;
        }.bind(this);

        this.isBankAccountAvailable = ko.pureComputed(function () {
            return this.bankAccounts.hasData() && this.bankAccounts.data().length > 0;
        }, this);

        this.canSubmit = ko.pureComputed(function () {
            return !this.addOrEditRequest.isLoading() && !this.validation.hasErrors();
        }, this);

        this.method = {
            canEdit: ko.computed(function () {
                return $.cdh.employee.allowedToUpdateDirectDepositInformation();
            }.bind(this))
        };

        this.clickSubmit = function () {
            this.validation.activate();

            if (!this.canSubmit())
                return;

            this.addOrEditRequest
                  .load(ko.toJS(this.contribution))
                  .done(function () {
                      this.success(true);
                  }.bind(this));
        }

        this.clickPreview = function () {
            this.validation.activate();

            if (!this.canSubmit())
                return;

            this.preview(true);
        }.bind(this);

        this.clickEdit = function () {
            this.preview(false);
        }.bind(this);

        this.clickOk = function () {
            if ($.isFunction(this.close))
                this.close();
            if ($.isFunction(onSuccess))
                onSuccess();
            return false;
        }.bind(this);
    }


    $.extend(true, $, {
        cdh: {
            models: {
                ContributionsAddEditPopup: contributionsAddEditPopup
            }
        }
    });
})(jQuery, ko);